import { App } from "@capacitor/app";
import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppLogo } from "shared/ui/app-logo";
import { HelpContacts } from "widgets/help-contacts";

export const HelpPage = () => {
  const { t } = useTranslation();
  const [version, setVersion] = useState<string>("");

  useEffect(() => {
    App.getInfo()
      .then((info) => setVersion(info.version))
      .catch(() => setVersion(""));
  }, []);

  return (
    <div>
      <AppLogo
        style={{
          margin:
            "calc(82px + var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))) 0 28px 0",
        }}
      />
      <Typography.Title level={3} style={{ textAlign: "center" }}>
        {t("support.something_went_wrong")}
      </Typography.Title>
      <Typography.Text
        style={{
          fontSize: 16,
          marginBottom: 48,
          display: "block",
          color: "var(--color-grey)",
          textAlign: "center",
        }}
      >
        {t("support.any_questions")}
      </Typography.Text>

      <HelpContacts />

      {version && (
        <Typography.Text
          style={{
            fontSize: 16,
            marginTop: 48,
            marginBottom: 48,
            display: "block",
            color: "var(--color-grey)",
            textAlign: "center",
          }}
        >
          {t("support.version")}: {version}
        </Typography.Text>
      )}
    </div>
  );
};
